/**
 * Import Dependency
 */
import * as _ from 'lodash'
import axios from 'axios'
import store from '../../store'
import { baseUrl } from './config'
import { refreshUser, registerUser } from '../../actions/components/user'
import { createBasket } from '../../actions/components/basket'
/**
 * Config
 */
axios.defaults.timeout = 10000
// let isTokenDirty = false;

const getConfig = (err) => {
  if (err && err.config) {
    return err.config
  }
}

const sanitizeError = (error) => {
  try {
    const data = JSON.parse(error.config.data)
    if (data.payment.payload.paymentMethod.paymentCard) {
      delete data.payment.payload.paymentMethod.paymentCard
    }
    error.config.data = JSON.stringify(data)
  } catch (e) { }
  return error
}

axios.interceptors.request.use(config => {
  if (config.url.startsWith(baseUrl)) {
    if (!config.skipAuthorization) {
      const user = store.getState().user
      if (user) {
        config.headers.Authorization = `TOKEN ${user.token}`
        // if (isTokenDirty) {
        //     user.token = user.token.split('123')[0];
        //     config.headers.Authorization = `TOKEN ${user.token}`;
        // } else {
        //     isTokenDirty = true;
        //     user.token = user.token + '123';
        // config.headers.Authorization = `TOKEN ${user.token}`;
        // }
      }
    }

    const locale = store.getState().locale
    if (locale) {
      config.headers['Accept-Language'] = locale
    }

    if (!config.params) {
      config.params = {}
    }
    if (!config.params._t) {
      config.params._t = (new Date()).getTime()
    }
  }
  return config
}, error => {
  console.group('[Axios][Interceptor] Request Error')
  error = sanitizeError(error)
  console.error(error)
  console.groupEnd()
  return Promise.reject(error)
})

axios.interceptors.response.use(data => {
  return data
}, error => {
  console.group('[Axios][Interceptor] Response Error')
  error = sanitizeError(error)
  console.error(error)

  if (error.response && error.response.data && error.response.status) {
    console.error({
      type: 'ajax error',
      request: {
        method: error.config.method,
        url: error.config.url,
        data: error.config.data,
        params: error.config.params,
      },
      response: {
        data: error.response.data,
        status: error.response.status,
      },
    })
  }

  const res = error.response
  if (res && res.status === 406 &&
        res.data &&
        res.data.error === 'token expired') {
    const user = store.getState().user
    if (user) {
      return store.dispatch(refreshUser(user.refresh)).then(() => {
        return axios.request(error.config)
      })
    }
  } else if (res && res.status === 401 &&
        res.data &&
        res.data.error === 'signature is invalid') {
    return store.dispatch(registerUser()).then(() => {
      return store.dispatch(createBasket({ merchantId: store.getState().basket.merchantId, table: store.getState().basket.table })).then(async () => {
        return axios.request(error.config)
      })
    })
  }
  console.groupEnd()
  return Promise.reject(error)
})

// config.currentRetryAttempt: 目前重試次數
// config.retry:
// config.retryDelay:

const shouldRetryRequest = (error) => {
  const config = getConfig(error) || {}
  config.currentRetryAttempt = config.currentRetryAttempt || 0

  if (!config.retry) {
    return false
  }

  // If we are out of retry attempts, return
  config.currentRetryAttempt = config.currentRetryAttempt || 0
  if (config.currentRetryAttempt >= config.retry) {
    return false
  }

  return true
}
axios.interceptors.response.use(data => { return data || {} }, error => {
  console.log('retry interceptor', error)
  const config = getConfig(error) || {}

  config.currentRetryAttempt = config.currentRetryAttempt || 0
  config.retryDelay = config.retryDelay || 500

  // Determine if we should retry the request
  const shouldRetryFn = config.shouldRetry || shouldRetryRequest
  if (!shouldRetryFn(error)) {
    return Promise.reject(error)
  }

  // Create a promise that invokes the retry after the backOffDelay
  const onBackoffPromise = new Promise(resolve => {
    const delay = config.retryDelay

    // We're going to retry!  Incremenent the counter.
    config.currentRetryAttempt += 1
    setTimeout(resolve, delay)
  })

  // Return the promise in which recalls axios to retry the request
  return Promise.resolve()
    .then(() => onBackoffPromise)
    .then(() => axios.request(error.config))
})

/**
 * Export
 */
export default axios



// WEBPACK FOOTER //
// ./src/services/api/interceptor.js